import script from "./CheckboxMultipleSelectComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckboxMultipleSelectComponent.vue?vue&type=script&setup=true&lang=js"

import "./CheckboxMultipleSelectComponent.vue?vue&type=style&index=0&id=7c3f240c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c3f240c"]])

export default __exports__